<template>
  <div>
    <home-hero />

    <testimonials />
    <news />
    <div class="container my-5" style="margin-top: 150px!important;">
      <div class="row">
        <div class="col-12 d-sm-none d-block mb-5">
          <img :src="require('../assets/images/phone.png')" class="img-fluid" />
        </div>
        <div class="col-md-6">
          <h2 class="mb-4">Ahora sí, el Talmud es para todos</h2>
          <h5
            class="font-weight-normal mb-5"
          >Estudia la fuente principal del judaísmo en español, a tu ritmo y estés donde estés</h5>
          <router-link :to="'/descubre'" class="btn btn-primary btn-lg btn-responsive px-4 mr-3 mb-2">Descubre la app</router-link>
          <router-link :to="'/participa'" class="btn btn-tertiary btn-lg btn-responsive px-4 mb-2">Anticipa la próxima versión</router-link>
        </div>
        <div class="col-6 d-none d-sm-block">
          <img :src="require('../assets/images/phone.png')" class="img-fluid" />
        </div>
      </div>
    </div>
    <equipo/>
    <futuro @openDonations="openDonations" @openKetarim="openKetarim"/>
    <transition name="fade" mode="out-in">
      <div class="futuro py-5 mb-5" v-show="showDonations">
        <donations id="donations" ref="donations"/>
      </div>
    </transition>
    <transition name="fade" mode="out-in">
      <ketarim v-show="showKetarim"/>
    </transition>
  </div>
</template>
<script>
import HomeHero from "./HomeHero";
import Testimonials from "./Testimonials";
import News from "./News";
import Equipo from "./Equipo";
import Futuro from "./Futuro";
import Donations from './Donations'
import Ketarim from './Ketarim'
export default {
  components: {
    HomeHero,
    Testimonials,
    News,
    Futuro,
    Equipo,
    Donations,
    Ketarim,
  },
  data() {
    return {
      showDonations: false,
      showKetarim: false,
    }
  },
  methods: {
    openDonations () {
      this.showDonations = true
      this.$nextTick(() => {
        var element_to_scroll_to = document.getElementById('donations');
        element_to_scroll_to.scrollIntoView();
      })
    },
    openKetarim () {
      this.showDonations = true
      this.showKetarim = true
      this.$nextTick(() => {
        var element_to_scroll_to = document.getElementById('donations');
        element_to_scroll_to.scrollIntoView();
      })
    }
  },
};
</script>
<style lang="scss">
html, body{
    scroll-behavior: smooth;
}
@media (max-width: 768px) {
  .btn.btn-responsive {
    padding-left: 15px!important;
    padding-right: 15px!important;
    font-size:80%!important;
    line-height: 1;
  }
}

</style>